<template>
  <div :style="cssProbs">
    <label class="switch switch-flat">
      <input
        ref="checkbox"
        v-model="checked"
        class="switch-input"
        type="checkbox"
        @focus="handleFocus">
      <span
        :data-off="textUnchecked"
        :data-on="textChecked"
        class="switch-label"
        @mousedown="handleMouseDown"
        @mouseup="handleMouseUp" />
      <span class="switch-handle" />
    </label>
  </div>
</template>

<script>
export default {
  props: {
    textUnchecked: {
      type: String,
      default: 'NO'
    },
    textChecked: {
      type: String,
      default: 'YES'
    },
    colorChecked: {
      type: String,
      default: '#238a15'
    },
    colorUnchecked: {
      type: String,
      default: '#fa3250'
    },
    preSelected: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      mouseDown: false,
      checked: this.value
    }
  },
  computed: {
    cssProbs () {
      return {
        '--checked-color': this.colorChecked,
        '--unchecked-color': this.colorUnchecked
      }
    }
  },
  watch: {
    checked (newVal, oldVal) {
      this.$emit('input', newVal)
    },
    value () {
      if (this.value !== this.checked) {
        this.checked = this.value
      }
    }
  },
  mounted () {
    this.checked = this.value
  },
  methods: {
    handleMouseDown () {
      this.mouseDown = true
    },
    handleMouseUp () {
      setTimeout(() => {
        this.mouseDown = false
      }, 100)
    },
    handleFocus (event) {
      if (this.mouseDown) {
        this.$refs.checkbox.blur()
      }
    }

  }
}
</script>

<style lang="scss">
@import "../../variables.scss";
.switch {
  position: relative;
  display: block;
  vertical-align: top;
  width: 100px;
  height: 30px;
  padding: 3px;
  margin: 0 10px 10px 0;
  background: linear-gradient(to bottom, #eeeeee, #FFFFFF 25px);
  border-radius: 18px;
  box-shadow: inset 0 -1px white, inset 0 1px 1px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  box-sizing:content-box;
}
.switch-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  box-sizing:content-box;
}

.switch-label {
  position: relative;
  display: block;
  height: inherit;
  font-size: 10px;
  text-transform: uppercase;
  border-radius: inherit;
  box-sizing:content-box;
}
.switch-input:focus ~ .switch-label {
  border: 2px solid black !important;
}
.switch-label:before, .switch-label:after {
  position: absolute;
  top: 50%;
  margin-top: -.5em;
  line-height: 1;
  -webkit-transition: inherit;
  -moz-transition: inherit;
  -o-transition: inherit;
  transition: inherit;
  box-sizing:content-box;
}
.switch-label:before {
  content: attr(data-off);
  right: 11px;
  color: black;
}
.switch-label:after {
  content: attr(data-on);
  left: 11px;
  color: black;
  opacity: 0;
}
.switch-input:checked ~ .switch-label {
  background: #E1B42B;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15), inset 0 0 3px rgba(0, 0, 0, 0.2);
}
.switch-input:checked ~ .switch-label:before {
  opacity: 0;
}
.switch-input:checked ~ .switch-label:after {
  opacity: 1;
}
.switch-handle {
  position: absolute;
  border-radius: 100%;
}
.switch-input:checked ~ .switch-handle {
  left: 74px;
  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
}

/* Transition
========================== */
.switch-label, .switch-handle {
  transition: All 0.3s ease;
  -webkit-transition: All 0.3s ease;
  -moz-transition: All 0.3s ease;
  -o-transition: All 0.3s ease;
}
.switch-flat {
  padding: 0;
  background: #FFF;
  background-image: none;
}
.switch-flat .switch-label {
  background-color: #FFF;
  border: solid 2px $errorRed;
  border: solid 2px var(--unchecked-color);
  box-shadow: none;
}
.switch-flat .switch-handle {
  top: 6px;
  left: 6px;
  background-color: $errorRed;
  background-color: var(--unchecked-color);
  width: 22px;
  height: 22px;
  box-shadow: none;
}
.switch-flat .switch-handle:before {
  background: #eceeef;
}
.switch-flat .switch-input:checked ~ .switch-label {
  background: #FFF;
  border-color: $successGreen;
  border-color: var(--checked-color);
}
.switch-flat .switch-input:checked ~ .switch-handle {
  left: 72px;
  background-color: $successGreen;
  background-color: var(--checked-color);
  box-shadow: none;
}

</style>
